<template>
  <div id="app">



    <div class="main">
        <div style="max-width:720px;margin:0 auto; line-height:1.3;">


 <h2 style="border-bottom:2px solid #c4a022;/*#d5d77b*/; padding-bottom:15px">
  <img src="./assets/logo mtessP.png" alt="" width="140">
  <span style="font-size: 39px;  position: relative;color:#c4a022">وزارة العمل و التشغيل و الضمان الاجتماعي</span>
  <br>
      <div style=" position: relative;">الإجراءات والتدابير الاستثنائية المتعلقة بإلغاء العقوبات الناجمة عن التأخر في تسديد الاشتراكات <span class="btnMain" :class="showBTN" @click="GoBack"><span class="material-icons">
keyboard_return
</span></span></div>

    </h2>
        </div>

    <vs-tabs alignment="center">

      <vs-tab label="البيانات الصحفية">
        <div>
            <!-- FIRST DATA -->


 <div>
    <vs-table stripe :data="Bayane" class="oTable">
      <template slot="header">

      </template>
      <template slot="thead">
        <vs-th>
          تحميل
        </vs-th>
        <vs-th>
          تاريخ
        </vs-th>
        <vs-th>
          الملف
        </vs-th>
        <vs-th>
          الرقم
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="opopop" >

          <vs-td :data="data[indextr].username">
            <a class="iMilaf" target="_blank" :href="getIp('public/files/Bayane/'+ data[indextr].hashed_filename + '.pdf')">الملف</a>
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].date}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].filename}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{indextr + 1}}
            <!-- {{data[indextr].id}} -->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>

<!-- <div class="paginate" >
    <vs-pagination color="#f91f43" :total="20" v-model="currentx"></vs-pagination>
  </div> -->

            <!-- FIRST DATA -->
        </div>
      </vs-tab>
      <vs-tab label="معرض الصحافة" >

        <div>
          

            <div class="subs-wrapper" style="min-height:280px">
              <div class="topWrapper">
              <vs-row  class="subWrapper" :class="subWrapperCNAS">
                <vs-col vs-type="flex" vs-w="12">

<vs-table stripe :data="Cnas" class="oTable" style="width:100%">
      <template slot="header">
        <!-- <h1>CNAS</h1> -->
      </template>
      <template slot="thead">
        <vs-th>
          تحميل
        </vs-th>
        <vs-th>
          تاريخ
        </vs-th>
        <vs-th>
          الملف
        </vs-th>
        <vs-th>
          الرقم
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="opopop"  >

          <vs-td :data="data[indextr].username">

<a class="iMilaf" target="_blank" :href="getIp('public/files/Ma3rad/'+ data[indextr].hashed_filename + '.pdf')">الملف</a>
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].date}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].filename}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{indextr + 1}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

                </vs-col>
              </vs-row>




<vs-row  class="subWrapper" :class="subWrapperCASNOS">
                <vs-col vs-type="flex" vs-w="12">

<vs-table stripe :data="Casnos" class="oTable" style="width:100%">
      <template slot="header">
        <h2>CASNOS</h2>
      </template>
      <template slot="thead">
        <vs-th>
          تحميل
        </vs-th>
        <vs-th>
          تاريخ
        </vs-th>
        <vs-th>
          الملف
        </vs-th>
        <vs-th>
          الرقم
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="opopop" >

          <vs-td :data="data[indextr].username">

          <a class="iMilaf" target="_blank" :href="getIp('public/files/Ma3rad/'+ data[indextr].hashed_filename + '.pdf')">الملف</a>
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].date}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].filename}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{indextr + 1}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

                </vs-col>
              </vs-row>



<vs-row  class="subWrapper" :class="subWrapperCACO">
                <vs-col vs-type="flex" vs-w="12">

<vs-table stripe :data="Caco" class="oTable" style="width:100%">
      <template slot="header">
        <h2>CACO</h2>
      </template>
      <template slot="thead">
        <vs-th>
          تحميل
        </vs-th>
        <vs-th>
          تاريخ
        </vs-th>
        <vs-th>
          الملف
        </vs-th>
        <vs-th>
          الرقم
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="opopop"  >

          <vs-td :data="data[indextr].username">

<a class="iMilaf" target="_blank" :href="getIp('public/files/Ma3rad/'+ data[indextr].hashed_filename + '.pdf')">الملف</a>
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].date}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].filename}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{indextr + 1}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

                </vs-col>
              </vs-row>
            </div> <!-- wrapper -->

              <!--  -->
              <vs-row class="BoxesWrapper" :class="wrapperClassCNAS">
                <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    
                    <div class="SubBox" @click="GotoCnas" >
                        <div class="cnas">
                      <div class="icon "></div>
                        </div>
                        <p class="pone">الصندوق الوطني للتأمينات الاجتماعية للعمال الأجراء </p>
                        <p class="ptwo">CNAS</p>
                    </div>

                </vs-col>



                <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    
                    <div class="SubBox" @click="GotoCasnos">
                        <div class="casnos">
                      <div class="icon"></div>
                        </div>
                        <p class="pone">الصندوق الوطني ﻟﻠﻀﻤﺎﻥ ﺍﻻﺠﺘﻤﺎﻋﻲ ﻟﻐﻴﺭ ﺍﻷﺠﺭﺍﺀ</p>
                        <p class="ptwo">CASNOS</p>

                    </div>

                </vs-col>



                <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    
                    <div class="SubBox" @click="GotoCaco">
                        <div class="caco">
                      <div class="icon"></div>
                        </div>
                        <p class="pone">الصندوق الوطني للعطل المدفوعة الأجر والبطالة الناجمة عن سوء أحوال الجوية لقطاعات البناء والأشغال العمومية والري </p>
                        <p class="ptwo">CACOBATH</p>

                    </div>

                </vs-col>
              </vs-row>
            </div>


        </div>
      </vs-tab>
      <vs-tab label="فيديوهات">
        <div>


<vs-table stripe :data="videos" class="oTable" style="width:100%">

      <template slot="thead">
        <vs-th>
          تشغيل الفيديو
        </vs-th>
        <vs-th>
          تاريخ
        </vs-th>
        <vs-th>
          الملف
        </vs-th>
        <vs-th>
          الرقم
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr style="cursor:pointer" :key="indextr" v-for="(tr, indextr) in data" class="opopop" >

          <vs-td class="opoa">
            <span @click="showItem(data[indextr])"  class="material-icons-outlined" style="color:#f91f43;transform:rotate(180deg)">
play_circle_outline
</span>
          </vs-td>

          <vs-td >
            {{data[indextr].date}}
          </vs-td>

          <vs-td >
            {{data[indextr].filename}}
          </vs-td>

          <vs-td >
            {{indextr + 1}}
            <!-- {{data[indextr].id}} -->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
          <!-- <iframe :src="iframeSource" frameborder="0"></iframe> -->

        </div>
      </vs-tab>

    </vs-tabs>
    </div>

    <div id="videoOverflow" :class="showFade" @click="hideVideo"></div>
    <div id="videoSlider" :style="styleVideoSlider">
        <!-- <iframe :src="iframeSource"  width="560" height="315" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->


<vue-plyr  v-if="canPlay" ref="op">
  <div data-plyr-provider="youtube" :data-plyr-embed-id="currentEmbed"></div>
</vue-plyr>

        <div id="ControleBTN">
          <span class="material-icons" style="transform:rotate(180deg)">  arrow_back_ios_new  </span>
          <span class="material-icons"> arrow_back_ios_new   </span>
        </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
export default {

  name: 'App',

    metaInfo: {
      title: 'الإجراءات والتدابير الاستثنائية المتعلقة بإلغاء العقوبات الناجمة عن التأخر في تسديد الاشتراكات ',
      titleTemplate: '%s لوزارة العمل و التشغيل و الضمان الاجتماعي',
      htmlAttrs: {
        lang: 'ar',
        amp: true
      }
    },
   data() {
    return {
      firstHidden : false,
      Cnas : [],
      Caco : [],
      Casnos : [],
      Bayane:[],
      canPlay: false,
      PlayerOPlayer:{},
      datas:{},

      videos : [
        {
          name:'',
          date:'',

        }
      ],
      currentEmbed:'',
      styleVideoSlider: '',
      showFade : '',
      iframeSource : '',
      wrapperClassCNAS : '',
      wrapperClassCACO : '',
      wrapperClassCANOS : '',
      subWrapperCNAS: 'hide',
      subWrapperCASNOS: 'hide',
      subWrapperCACO: 'hide',
      showBTN : '',
      // colorx: '#f91f43',
    currentx: 1,
      // colorx:'Danger',

    users:[
      {
        "id": 1,
        "name": "Leanne Graham",
        "username": "Bret",
        "email": "Sincere@april.biz",
        "website": "hildegard.org",
      },
      {
        "id": 2,
        "name": "Ervin Howell",
        "username": "Antonette",
        "email": "Shanna@melissa.tv",
        "website": "anastasia.net",
      },
      {
        "id": 3,
        "name": "Clementine Bauch",
        "username": "Samantha",
        "email": "Nathan@yesenia.net",
        "website": "ramiro.info",
      },
     
    ]


    };
  },
  
  mounted(){
    // this.$playerOplayer.on('ready',()=>{alert('OK')})
    
    console.log('FROM MTESS@2021 by Younes Keraressi.');
    axios.get( this.$ip ).then(res=>{
    this.Bayane = res.data.Bayane;
    this.videos = res.data.Video;
    this.Cnas = res.data.Ma3rad.cnas;
    this.Caco = res.data.Ma3rad.caco;
    this.Casnos = res.data.Ma3rad.casnos;
    // console.log( 'this.videos --->',  this.videos )
    })
    //
    // console.dir( document.lastChild.classList.remove('vuesax-app-is-ltr') )
    // let lastChild = document.lastChild;
    // var xtmp = setInterval(()=>{
    //     if(lastChild.classList.contains('vuesax-app-is-ltr'))
    //     {
    //       lastChild.classList.remove('vuesax-app-is-ltr');
    //       // clearInterval(xtmp);
    //     }
    // }, 10000)


//     setTimeout(()=>{
//       document.lastChild.classList.remove('vuesax-app-is-ltr')
// this.iframeSource = "https://www.youtube.com/embed/Fq5KwGu0EB4";
//     }, 3000)
    
  },

  methods:{
getIp( str ){
  return this.$ip + str;
},
ActionController: function(event) {
           // console.log(event.detail.plyr.currentTime) // to get current time, DON'T FORGET REMOVE IT, just for check 😊
          },
          endedAction: function(event) {
            //console.log('end')
          },

    hideVideo(){
      this.firstHidden = true;
      this.$children[1].player.pause();

      // setTimeout(()=>{
      // this.styleVideoSlider = {
      //   display:"block",
      // } 
      // }, 500)
        this.styleVideoSlider = {
          display:"none",
          } 
      this.showFade = '';
      this.currentEmbed = ''; 

      // let pauses = document.querySelectorAll('.plyr__control--pressed');
      // if(pauses.length > 0){
      //   pauses[0].click();
      // }
// plyr plyr--full-ui plyr--video plyr--youtube plyr--fullscreen-enabled plyr__poster-enabled plyr--paused

//plyr plyr--full-ui plyr--video plyr--youtube plyr--fullscreen-enabled plyr--paused plyr--stopped plyr__poster-enabled
// document.querySelector('#videoSlider > div')
      // console.log( 'HIDE VIDEO', this.currentEmbed );
      // console.log( document.querySelector('#op')) ;
    },
    showItem( $item ){

      // console.log( $item.embed_url );
      // console.log('***', this.player, this.$refs.op.player)

      if( this.firstHidden ){
          this.$children[1].player.source = {
                  type: 'video',
                  sources: [
                    {
                      src: $item.embed_url,
                      provider: 'youtube',
                    },
                  ],
                };

      }
      else
      this.currentEmbed = $item.embed_url;//'H-YjtRTzitk';$item.embed_url;//{};'qlcQHdR8VUs'//$item.embed_url
      //console.log('GG');
      this.showFade = 'show';
      setTimeout(()=>{
      this.styleVideoSlider = {
        display:"block",
      } 

      this.canPlay = true;
       //.$children[1].$vnode.player)
      }, 500)

    },
    GoBack(){
      this.wrapperClassCNAS = '';
      this.subWrapperCNAS = 'hide';
      this.subWrapperCNAC = 'hide';
      this.subWrapperCASNOS = 'hide';
      this.subWrapperCACO = 'hide';

      this.showBTN = ''; 
    },
    GotoCnas(){
      //console.log('CLICK')
      this.wrapperClassCNAS = 'hide';
      this.subWrapperCNAS = '';
      this.showBTN = 'show';
      // BoxesWrapper
//transform: translateY(-200px);
    },

    GotoCaco(){
     // console.log('CLICK')
      this.wrapperClassCNAS = 'hide';
      this.subWrapperCACO = '';
      this.showBTN = 'show';
      // BoxesWrapper
//transform: translateY(-200px);
    },
    GotoCasnos(){
      //console.log('CLICK')
      this.wrapperClassCNAS = 'hide';
      this.subWrapperCASNOS = '';
      this.showBTN = 'show';
      // BoxesWrapper
//transform: translateY(-200px);
    }

  },

};
</script>


<style>

html{
  direction: rtl;
}
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  font-family: bnorm;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;width: 100%;
}
h1,h2,h3,h4,h5,h6{font-weight: bold;}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

html{
      background: linear-gradient(45deg, #f7f7f7, #f7f7f6);
        /*background: url('~@/assets/header.png') no-repeat;*/
  background-size: cover;
}
body{
  background: url('~@/assets/header.png') no-repeat;
  background-size: cover;
      height: 100vh;
    width: 100vw;
    /*display: flex;*/
    background-position: center center;
    align-items: center;
}

.main{
   /*height: 100vh;*/
  position: relative;
  width: 90%;
    margin: 0 auto;
        border-radius: 6px;
    background: rgba(255,255,255,0.93);
    padding: 1.5rem;
    align-items: center;
    box-shadow: 0 5px 28px 0 rgb(63 79 110 / 35%);

}
.vs-tabs--btn > span{font-weight: bold;}
.SubBox{
  margin-top: 25px;
  background: #fefefe;
    padding: 15px;
    /* text-align: center; */
    box-shadow: 0 2px 15px 0 rgb(63 79 110 / 35%);
    /* border: 2px solid #3fafdd; */
    border-radius: 8px;
        max-width: 250px;
        cursor: pointer;
        transition: all .25s ease;
        transform: translateX(0);
          height: calc(100% - 25px);
}
.SubBox:hover{
  transform: translateY(-15px);
}
.SubBox > div{margin-top: 25px; cursor: pointer;}
.SubBox > div.cnas{
  padding: 10px;
      display: inline-block;
      background: linear-gradient( 
135deg, #1bacb1 0, #1e8bb1 27%, #142869);
      border-radius: 8px; box-shadow: 0 0 4px #00000094;
      background: #fff;
      border: 2px solid #1b6c9a; border-radius: 8px;

}

.SubBox > div.caco{
  padding: 10px;
    display: inline-block;
    background: linear-gradient( 
135deg, #ffffff 0, #ffffff 27%, #ffffff);
    border-radius: 8px;
    box-shadow: 0 0 4px #00000094;
    border: 3px solid #f16638;
}

.SubBox > div.casnos{
  padding: 10px;
    display: inline-block;
    background: linear-gradient( 135deg, #ffffff 0, #ffffff 27%, #ffffff);
    border-radius: 8px;
    box-shadow: 0 0 4px #00000094;
        border: 3px solid #1a4e93;
}

.SubBox  .icon{ width: 65px; height: 65px;margin: 0 auto;}
.SubBox p{font-size: 14px; font-weight: bold; margin-top: 15px;    line-height: 1.5;}
/*.SubBox > div.cnas > div{background-image: url(/img/cnas.a4d0cd3b.svg);}*/
.SubBox > div.cnas > div{background-image: url('~@/assets/cnas.svg');background-repeat: no-repeat;}
.SubBox > div.caco > div{background-size: 100px 100px;background-position: center;background-image: url(assets/caco.svg);background-repeat: no-repeat;}

.SubBox > div.casnos > div{background-size: 100px 100px;background-position: center;background-image: url(assets/casnos.svg);
    background-size: 100%;
    background-position: 3px center;
    background-image: url(/img/casnos.d2723c45.svg);
    background-repeat: no-repeat;}
/*.SubBox .icon.cnas{ background: url('~@/assets/cnas.svg') ;background-image: url(/img/cnas.a4d0cd3b.svg), linear-gradient( 
135deg, #1bacb1 0, #1e8bb1 27%, #142869);
    background-repeat: no-repeat;
    border-radius: 120px; 

  background: url(/img/cnas.a4d0cd3b.svg); background-image: url(/img/cnas.a4d0cd3b.svg), linear-gradient( 135deg, #1bacb1 0, #1e8bb1 27%, #142869); background-repeat: no-repeat; border-radius: 8px; box-shadow: 0 0 4px #00000094;
}*/

.paginate > div > div{ justify-content: center!important;  }

.oTable tr {
  direction: rtl!important; display: flex; width: 100%; flex-direction: row-reverse;
}
.oTable tr >*:last-child{ flex: 1; }
.oTable tr >*:nth-child(3){ flex: 3; }
.oTable tr >*:nth-child(2){ flex: 2; }
.oTable tr >*:nth-child(1){ flex: 2; }
.oTable tr{text-align:right;}
.BoxesWrapper{
  position: absolute;
top: 0;
}
.BoxesWrapper ,.subWrapper {

  transform: translateY(0px); opacity: 1; 
  
  transition: all 450ms cubic-bezier(0.68, -0.55, 0.265, 1.55);;
  /*position: absolute;*/
  /*top: 0;*/
  /*transition: all 1s cubic-bezier(0.64, 0.57, 0.67, 1.53);*/
}
.BoxesWrapper.hide,.subWrapper.hide{transform: translateY(-250px); opacity: 0;}

.btnMain{
  cursor:pointer;position:absolute; right:-35px;background: #c09a02; color: #fff; border-radius: 4px;bottom: -90px; ;z-index: 9999999;
  transform: translateX(38px);
  opacity: 0;
  transition: all 450ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.btnMain.show{
  opacity: 1;
  transform: translateX(-38px);
}
.btnMain > span{height: 45px; width: 45px; display: flex; align-items: center; justify-content: center;}

.topWrapper > *:nth-child(2){ position: absolute; top: 0; }
.topWrapper > *:nth-child(3){ position: absolute; top: 0; }
#videoOverflow{top: 0; width: 100%; height: 100%; position: fixed; background: #000; opacity: 0; z-index: -1; 
  transition: all 650ms cubic-bezier(0.68, -0.55, 0.265, 1.55);;
 }
 #videoOverflow.show{  opacity: .8; z-index: 99999999}
#videoSlider{
display: none;
  border: 5px solid #c4a022; max-width: 800px  ; height: 500px; position: fixed; top: 0;z-index: 99999999; top: 0; left: 0; right: 0;bottom: 0; margin:  auto;
transition-delay: 200ms;
opacity: 1;
  transition: opacity 450ms ease}
  /*#videoSlider.show{opacity: 1;z-index: 99999999;}*/

#videoSlider > *{width: 100%; height: 100%;}
#ControleBTN{display: none;}
.iMilaf{color: #c4a022}
.opopop > td{display: flex; align-items: center;}
.opoa > span{display: flex;}
.td.vs-table--td{
  font-size: 16px;
    line-height: 1.2;
}

.ptwo{font-weight: bold; display: none; margin-top: 0!important;margin-bottom: 5px;}
/*#videoSlider #ControleBTN {height: 110px; width: 145%;  padding: 10px; position: absolute;left: 50%; transform: translate(-50%, -50%); top: 50%; z-index: -1; display: flex; align-items: center; justify-content: space-between;}
#ControleBTN > .material-icons{font-size: 64px; color: #fff; cursor: pointer;}*/
.vs-tabs--content{padding: 0!important;}
@media screen and (max-width:  1170px){
  .SubBox{ padding: 5px; }
}
@media screen and (max-width:  980px){
  #videoSlider{height: 70%;}
  .pone{display: none;}
  .ptwo{display: block;}
  .SubBox{width: 153px;}
  h2 span{ font-size: 28px!important; top: unset!important; }
  h2 div{top: unset!important;font-size: 22px;}

h2 img{ width: 100px; height: 100px; display: block;
    margin: 0 auto;}
  /*.subs-wrapper{min-height: 680px!important;}*/
  /*.BoxesWrapper{flex-flow: column!important;}*/
  /*.BoxesWrapper > div, .BoxesWrapper > .SuBox{width: 100%!important;}*/
}
@media screen and (max-width:  644px){
  .main{padding-top: 0!important;}
  .SubBox{width: 120px;}
  .SubBox .icon{width: 45px;height: 45px;}
  .SubBox > div.caco > div{background-size: 100%;}
  #videoSlider{height: 50%;}
}

@media screen and (max-width:  542px){
  .SubBox{width: 100px;}
  .SubBox .icon{width: 32px;height: 32px;}
  h2 img{ width: 80px; height: 80px;}
  h2 span{ font-size: 22px!important }
  h2 div{font-size: 17px;}
}

@media screen and (max-width:  434px){
    h2 span{ font-size: 18px!important }
  h2 div{font-size: 14px;}
      #videoSlider{height: 32%;}
}
@media screen and (max-width:  396px){
  /*.SubBox .icon{width: 32px;height: 32px;}*/

  .SubBox {
    width: 80px;
    padding: 5Px;
    height: 133px;
    box-shadow: none;
}
  .SubBox p{font-size: 12Px;}


}


</style>
